<template>
  <div>
    <div class="l-block__header">
      <TitleSub level="h3">
        <span class="title">SEO評価項目</span>
      </TitleSub>
    </div>
    <Loading v-if="isLoading" variant="inline" />
    <Error v-else-if="!Object.keys(data).length" variant="inline" size="sm">
      <template slot="title">
        データがありません。
      </template>
    </Error>
    <DetailSeoEvaluationGraph v-else :data="data" isAnimate />
  </div>
</template>

<script>
import DetailSeoEvaluationGraph from '@/components/seo/DetailSeoEvaluationGraph';
import Error from '@/components/Error';
import Loading from '@/components/Loading';
import TitleSub from '@/components/TitleSub';

export default {
  props: ['data', 'isLoading'],

  components: {
    Error,
    DetailSeoEvaluationGraph,
    Loading,
    TitleSub
  }
};
</script>
